<script>
import ItemService from '@/services/ItemService.js'
import FullImg from '@/components/FullImg'

export default {
  name: 'ItemsView',
  components: { FullImg },
  data () {
      return {
          items: []
      }
  },
  async mounted () {
      this.items = await ItemService.getItems();
  }
}

</script>
<template>

<div class="items-view">

	<!-- <div class="toolbar">
		<div class=""></div>
	</div> -->

	<div class="">
		<div class="grid">
			<div class="cell" v-for="(item, index) in items" :key="index">
				<router-link :to="'/item/' + index" class="content" :data-flip-key="'item-' + item.id">
					<FullImg class="picture"
						:src="item.thumbnail.url"
						:align="item.thumbnail.align"
					/>
					<div class="info">
						<div class="label">{{ item.label }}</div>
						<div class="descr">{{ item.descr }}</div>
						<div class="descr">{{ item.material }}</div>
					</div>
				</router-link>
			</div>
		</div>
	</div>

</div>

</template>
<style scoped>

	.toolbar {
		position: sticky;
		top: 0;
		z-index: 10;
		padding: 1em 0;
	}

    .grid {
        display: flex;
        flex-flow: row wrap;
        align-content: flex-start;
		margin: 0 -.8em;
		margin-bottom: 3em;
    }
	.cell {
		padding: .8em;
    }

	.content {
		display: flex;
		align-items: center;
    }
	.content .info {
		flex: 1;
		margin-left: 1em;
	}

	/*** Theme ***/

	.toolbar {
		background-color: #3A3A3A;
		box-shadow: 0 0 20px rgba(0,0,0,.2);
	}

	.content {
		background-color: rgba(255,255,255,.05);
	}

	.picture {
		border-radius: 100%;
	}

	.info {
		margin-top: -.4em;
	}
	.label {
		font: var(--app-font-title);
		font-size: 180%;
		color: #FFF;
	}
	.descr {
		font: var(--app-font-text);
		font-size: 110%;
		color: #AAA;
	}

	.content {
		transition: all .2s;
		border: solid 1px transparent;
		box-shadow: 0 4px 10px rgba(0,0,0,.1);
	}
	.content:focus, .content:hover {
		transform: translateY(-2px);
		border-color: #ff7f00;
		box-shadow: 0 8px 20px rgba(0,0,0,.5);
	}

	/*** Responsive ***/

	.cell {
        width: 100%;
    }
	.content {
		padding: 1.4em;
    }
	.content .picture {
		width: 100px;
		height: 100px;
	}

	@media screen and (min-width: 768px) {
        .cell {
            width: 50%;
        }
    }

	@media screen and (min-width: 1280px) {
        .cell {
            width: 33%;
        }
    }

	@media screen and (max-width: 425px) {
		.cell {
			padding-top: .5em;
			padding-bottom: .5em;
		}
		.content .picture {
			width: 90px;
			height: 90px;
		}
    }

</style>
